import { CortexSetting, LocationVarKey } from "@swivl-mono/types";

import { CortexSettingRow } from "../../Components/CortexSettingRow";

export const TOPIC_VARS: LocationVarKey[] = [LocationVarKey.CortexMoveOutFormURL];

const MOVE_OUT_FORM_URL_SETTING: CortexSetting = {
  kind: "text",
  key: "moveOutFormURL",
  varKey: LocationVarKey.CortexMoveOutFormURL,
  label: "Move Out Form URL",
  description: "Customer-facing move out request form. When set, the bot can offer to text or email this link to a tenant who wants to move out.",
  placeholder: "https://example.com/move-out",
  default: ""
};

export function MoveOutTopic(): React.ReactElement {
  return (
    <section className="rounded-lg border border-grey-200 bg-white p-5">
      <CortexSettingRow setting={MOVE_OUT_FORM_URL_SETTING} />
    </section>
  );
}
